import request from "../../request";

export default {
  actions: {
    getCategories(_, data) {
      return request.get('categories', {
        params: data
      })
    },

    getAltCategories(_, data) {
      return request.get('alt-categories', {
        params: data
      })
    },
    getAltCategoriesById(_, data) {
      return request.get('alt-categories/'+ data)
    },


    createCategory(_, payload) {
      return request.post('categories', payload);
    },

    updateCategory(_, payload) {
      return request.put('categories/' + payload.id, payload);
    },

    deleteCategory(_, id) {
      return request.delete('categories/' + id);
    },
  }
}
